// import axios from './axios'
// import { isAccessTokenExpired, getRefreshedToken, setAuthUser } from './auth'
// import Cookies from 'js-cookie'
// import { API_BASE_URL } from './constant'

// const useAxios = () => {
//   const acccess_token = Cookies.get('access_token')
//   const refresh_token = Cookies.get('refresh_token')

//   const axiosInstance = axios.create({
//     baseURL: API_BASE_URL,
//     headers: {
//       Authorization: `Bearer ${acccess_token}`,
//     },
//   })
//   axiosInstance.interceptors.request.use(async (req) => {
//     if (!isAccessTokenExpired) {
//       return req
//     }
//     const response = getRefreshedToken(refresh_token)
//     setAuthUser(response.access, response.refresh)
//     req.headers.Authorization = `Bearer ${response.data?.access}`
//     return req
//   })
//   return axiosInstance
// }
// export default useAxios


// utils/axiosClient.js
// import axios from 'axios';
// import Cookies from 'js-cookie';
// import { getRefreshedToken, setAuthUser, isAccessTokenExpired } from './auth';
// import { API_BASE_URL } from './constant';

// const axiosInstance = axios.create({
//   baseURL: API_BASE_URL,
// });

// axiosInstance.interceptors.request.use(async (req) => {
//   let access_token = Cookies.get('access_token');
//   const refresh_token = Cookies.get('refresh_token');

//   if (isAccessTokenExpired()) {
//     try {
//       const response = await getRefreshedToken(refresh_token);
//       const new_access_token = response.data.access;
//       Cookies.set('access_token', new_access_token);
//       setAuthUser(new_access_token, response.data.refresh);
//       access_token = new_access_token;
//     } catch (err) {
//       console.error('Token refresh failed:', err);
//     }
//   }

//   req.headers.Authorization = `Bearer ${access_token}`;
//   return req;
// });

// export default axiosInstance;



// src/utils/axiosClient.js
import axios from 'axios';
import { API_BASE_URL } from './constant';
import Cookies from 'js-cookie';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Attach token before each request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
// Optional: handle 401s globally
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn('Unauthorized: redirecting or logging out...');
      // Optionally redirect to login or clear auth
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;



